var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMastercard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M35 21.943C35 23.079 34.074 24 32.931 24H2.07C.926 24 0 23.079 0 21.943V2.057C0 .921.926 0 2.069 0H32.93C34.074 0 35 .921 35 2.057v19.886z",
    transform: "translate(-250.000000, -723.000000) translate(16.000000, 699.000000) translate(191.000000, 23.999961) translate(43.000000, 0.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M1.47 21.943V2.057C1.47.921 2.398 0 3.54 0H2.069C.926 0 0 .921 0 2.057v19.886C0 23.079.926 24 2.069 24H3.54c-1.143 0-2.07-.921-2.07-2.057z",
    opacity: 0.15,
    transform: "translate(-250.000000, -723.000000) translate(16.000000, 699.000000) translate(191.000000, 23.999961) translate(43.000000, 0.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250.000000, -723.000000) translate(16.000000, 699.000000) translate(191.000000, 23.999961) translate(43.000000, 0.000000) translate(6.015625, 5.233666)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.836,
    cy: 6.797,
    fill: "#EB001B",
    rx: 6.836,
    ry: 6.797
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.201,
    cy: 6.797,
    fill: "#F79E1B",
    rx: 6.836,
    ry: 6.797
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2631B",
    d: "M11.519 1.845c1.325 1.24 2.153 3 2.153 4.952s-.828 3.712-2.153 4.952c-1.326-1.24-2.154-3-2.154-4.952 0-1.877.765-3.576 2.002-4.806z"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMastercard);
export { ForwardRef as ReactComponent };